import React from "react";
import {toDangerouslySetHtml} from "@/Utilities/htmlUtilities";

interface HtmlDisplayProps {
    buttonClassName?: string;
    className?: string;
    disabled?: boolean;
    html: string;
    isUpdatedLive?: boolean;
    isInline?: boolean;
    name?: string;
    onClick?: (...args: unknown[]) => unknown;
    title?: string;
}

export const HtmlDisplay = ({
                                buttonClassName = "",
                                className = "",
                                disabled = false,
                                name = "",
                                html,
                                isInline = false,
                                isUpdatedLive = false,
                                onClick = undefined,
                                title = "",
                            }: HtmlDisplayProps) => {

    const ariaLive = isUpdatedLive || onClick ? "polite" : "off";
    const props = {
        className: `htmlDisplay is-dangerouslySetHtml ${className}`,
        id: name,
        "data-testid": name,
        dangerouslySetInnerHTML: toDangerouslySetHtml(html),
    };

    const children = isInline ? <span {...props} aria-live={ariaLive}/> : <div {...props} aria-live={ariaLive}/>;

    return <> {onClick
        ? <button
            data-testid={name}
            disabled={disabled}
            id={name}
            onClick={onClick}
            className={buttonClassName}
            type={`button`}
            aria-label={title}
            title={title}
        >
            {children}
        </button>
        : children}
    </>;
};




















